import React from 'react';

const SectionHeader = ({ title, count, onRefresh, loading, actions }) => (
  <div className="section-header">
    <div className="section-header__left">
      <h2 className="section-header__title">{title}</h2>
      {count != null && <span className="section-header__count">{count}</span>}
    </div>
    <div className="section-header__right">
      {actions}
      <button
        className={`refresh-btn ${loading ? 'refresh-btn--spinning' : ''}`}
        onClick={onRefresh}
      >
        ↻
      </button>
    </div>
  </div>
);

export default SectionHeader;
